/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AcceptanceStatus {
    APPROVED = 'APPROVED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    REREQUESTED = 'REREQUESTED',
}
